module.exports = __webpack_public_path__ + "img/transporter-3.17385ac2.svg";